/**
 * @fileoverview POST handler for the "/app_groups/:app_group_id/placements" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsCacheKeys } from "./constants";
import type { PostAppGroupsAppGroupIdPlacementsProps, PostAppGroupsAppGroupIdPlacementsResult } from "./types";

export const postAppGroupsAppGroupIdPlacements = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsCacheKeys,
  ({
    placementId,
    name,
    description,
    appGroupId,
  }: PostAppGroupsAppGroupIdPlacementsProps): Promise<PostAppGroupsAppGroupIdPlacementsResult> => {
    return fetch(
      `/app_groups/${appGroupId}/placements`,
      "POST",
      {
        placement_id: placementId,
        name,
        description,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
